const getProgressPercent = (total: number, threshold: number | null): number => {
  if (!threshold) return 0;
  return Math.min((total / threshold) * 100, 100);
};

export default getProgressPercent;
